/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statistics_Day_Short_2Inputs */

const he_statistics_day_short_2 = /** @type {(inputs: Statistics_Day_Short_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ג`)
};

const en_statistics_day_short_2 = /** @type {(inputs: Statistics_Day_Short_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`T`)
};

/**
* | output |
* | --- |
* | "T" |
*
* @param {Statistics_Day_Short_2Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const statistics_day_short_2 = /** @type {((inputs?: Statistics_Day_Short_2Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statistics_Day_Short_2Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_statistics_day_short_2(inputs)
	return en_statistics_day_short_2(inputs)
});